export default __webpack_public_path__ + "static/media/patient-template.04aec828.csv";